import allPaths from '../Config/paths'
import { FaRegSmile, FaHeartbeat } from "react-icons/fa";
import { FaUserDoctor, FaRegEye, FaHeartCirclePlus } from "react-icons/fa6";
import { LiaStethoscopeSolid, LiaToothSolid } from "react-icons/lia";
import { GiStomach } from "react-icons/gi";

const menuItems = [
    {
        menuName: 'Home',
        menuALName: 'بيت',
        menuGLName: 'Heim',
        menuRoute: allPaths?.FOURHTHOME,
    },
    {
        menuName: 'About',
        menuALName: 'معلومات',
        menuGLName: 'Über',
        menuRoute: allPaths?.FOURHTABOUT,
    },
    {
        menuName: 'Services',
        menuALName: 'الخدمات',
        menuGLName: 'Dienstleistungen',
        menuRoute: allPaths?.FOURHTSERVICE,
    },
    {
        menuName: 'Doctors',
        menuALName: 'أرزتينن',
        menuGLName: 'Ärztinnen',
        menuRoute: allPaths?.FOURHTDOCTORS,
    },
    {
        menuName: 'Contact Us',
        menuALName: 'اتصل بنا',
        menuGLName: 'Kontaktieren Sie uns',
        menuRoute: allPaths?.FOURHTCONTACT,
    },
    {
        menuName: 'Content Form',
        menuALName: 'نموذج المحتوى',
        menuGLName: 'Inhaltsformular',
        menuRoute: allPaths?.FOURHTCONTENTFORM,
    },
];

const homeExperienceData = [
    {
        icon: <FaRegSmile />,
        title: 'Patients',
        glTitle: 'Patienten',
        alTitle: 'المرضى',
        quantity: 9501
    },
    {
        icon: <FaUserDoctor />,
        title: 'Doctors',
        glTitle: 'Ärztinnen',
        alTitle: 'الأطباء',
        quantity: 21
    },
    {
        icon: <FaHeartbeat />,
        title: 'Services',
        glTitle: 'Dienstleistungen',
        alTitle: 'خدمات',
        quantity: 23
    }
]
const serviceData = [
    {
        icon: <FaRegEye />,
        name: 'Ophthamology',
        alName: 'طب العيون',
        glName: 'Augenheilkunde'
    },
    {
        icon: <LiaStethoscopeSolid />,
        name: 'Internal Medicine',
        alName: 'الطب الباطني',
        glName: 'Innere Medizin'
    },
    {
        icon: <FaHeartCirclePlus />,
        name: 'General Checkup',
        alName: 'الفحص العام',
        glName: 'Allgemeine Untersuchung'
    },
    {
        icon: <LiaToothSolid />,
        name: 'Dentistry',
        alName: 'طب الأسنان',
        glName: 'Zahnmedizin'
    },
    {
        icon: <FaHeartbeat />,
        name: 'Cardiology',
        alName: 'طب القلب',
        glName: 'Kardiologie'
    },
    {
        icon: <GiStomach />,
        name: 'Hyperlipidimia',
        alName: 'ارتفاع الدهون في الدم',
        glName: 'Hyperlipidämie'
    },
];
const patientFeedBackData = [
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/31h.png',
        name: 'Zeyneb Azzam',
        caption: 'Had a smooth clean very professional experiences with them which i very much appreciate and highly recomended',
        alName: 'زينب عزام',
        alCaption: 'حظيت بتجارب احترافية سلسة ونظيفة للغاية معهم والتي أقدرها كثيرًا وأوصي بها بشدة',
        glName: 'Zeyneb Azzam',
        glCaption: 'Hatte eine reibungslose, sehr professionelle Reinigung mit ihnen, was ich sehr schätze und wärmstens empfehlen kann',
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Asset%201.png',
        name: 'Kiki Ismail',
        caption: 'Had a smooth clean very professional experiences with them which i very much appreciate and highly recomended',
        alName: 'كيكي اسماعيل',
        alCaption: 'حظيت بتجارب احترافية سلسة ونظيفة للغاية معهم والتي أقدرها كثيرًا وأوصي بها بشدة',
        glName: 'Kiki Ismail',
        glCaption: 'Hatte eine reibungslose, sehr professionelle Reinigung mit ihnen, was ich sehr schätze und wärmstens empfehlen kann',
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Asset%202.png',
        name: 'Omar Khairat',
        caption: 'Had a smooth clean very professional experiences with them which i very much appreciate and highly recomended',
        alName: 'عمر خيرت',
        alCaption: 'حظيت بتجارب احترافية سلسة ونظيفة للغاية معهم والتي أقدرها كثيرًا وأوصي بها بشدة',
        glName: 'Omar Khairat',
        glCaption: 'Hatte eine reibungslose, sehr professionelle Reinigung mit ihnen, was ich sehr schätze und wärmstens empfehlen kann',
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/32.png',
        name: 'Ahmed Essam',
        caption: 'Had a smooth clean very professional experiences with them which i very much appreciate and highly recomended',
        alName: 'احمد عصام',
        alCaption: 'حظيت بتجارب احترافية سلسة ونظيفة للغاية معهم والتي أقدرها كثيرًا وأوصي بها بشدة',
        glName: 'Ahmed Essam',
        glCaption: 'Hatte eine reibungslose, sehr professionelle Reinigung mit ihnen, was ich sehr schätze und wärmstens empfehlen kann',
    },
];
const latestOffer = [
    {
        "img": "https://www.cairocapitalclinics.com/images/Images/Asset%204.png",
        "title": "5% Discount on Medication",
        "alTitle": "خصم 5% على الأدوية",
        "glTitle": "5% Rabatt auf Medikamente"
    },
    {
        "img": "https://www.cairocapitalclinics.com/images/Images/parking.png",
        "title": "Free Parking",
        "alTitle": "موقف سيارات مجاني",
        "glTitle": "Kostenlose Parkplätze"
    },
    {
        "img": "https://www.cairocapitalclinics.com/images/Images/photo-1532187863486-abf9dbad1b69.jpeg",
        "title": "10% Discount on Lab Analysis",
        "alTitle": "خصم 10% على تحاليل المختبر",
        "glTitle": "10% Rabatt auf Labore analysieren"
    }
]

const aboutData = [
    {
        heading: 'Our Philosophy',
        text: 'Health care is a constant form of collaboration and innovation. There are always new fields to explore and new services to offer. And being a health service provider for over 30 years we learned to offer our clients with the latest technologies and best professionals while providing them with a personalized service that keeps them in their comfort zone.',
        alHeading: 'فلسفتنا',
        alText: 'الرعاية الصحية هي شكل دائم من التعاون والابتكار. هناك دائمًا مجالات جديدة لاستكشافها وخدمات جديدة لتقديمها. وبصفتنا مقدم خدمة صحية لأكثر من 30 عامًا، تعلمنا أن نقدم لعملائنا أحدث التقنيات وأفضل المهنيين مع تقديم خدمة مخصصة تبقيهم في منطقة راحتهم.',
        glHeading: 'Unsere Philosophie',
        glText: 'Gesundheitsversorgung ist eine ständige Form der Zusammenarbeit und Innovation. Es gibt immer neue Bereiche zu erkunden und neue Dienstleistungen anzubieten. Und als Gesundheitsdienstleister seit über 30 Jahren haben wir gelernt, unseren Kunden die neuesten Technologien und die besten Fachleute anzubieten und ihnen gleichzeitig einen personalisierten Service zu bieten, der sie in ihrer Komfortzone hält.'
    },
    {
        heading: 'Our Vision',
        text: 'Our vision is to offer our clients a personalized approach to feeling better and looking better. We know life can become very busy and this is why we have chosen the practicality of having all services centralized in one same prime location: from cosmetic dentistry, to nutrition, to dermatology, ophthalmology, cosmetology and many more.',
        alHeading: 'رؤيتنا',
        alText: 'رؤيتنا هي تقديم نهج مخصص لعملائنا للشعور بالتحسن والمظهر الأفضل. نعلم أن الحياة يمكن أن تصبح مشغولة جدًا ولهذا السبب اخترنا العملية المتمثلة في توحيد جميع الخدمات في موقع رئيسي واحد: من طب الأسنان التجميلي، إلى التغذية، إلى الأمراض الجلدية، طب العيون، علم التجميل والعديد من الخدمات الأخرى.',
        glHeading: 'Unsere Vision',
        glText: 'Unsere Vision ist es, unseren Kunden einen personalisierten Ansatz zu bieten, um sich besser zu fühlen und besser auszusehen. Wir wissen, dass das Leben sehr geschäftig werden kann, und deshalb haben wir die Praktikabilität gewählt, alle Dienstleistungen an einem zentralen Standort zu bündeln: von der kosmetischen Zahnheilkunde über Ernährung, Dermatologie, Augenheilkunde, Kosmetologie und viele mehr.'
    },
    {
        heading: 'Our Mission',
        text: 'Our mission is to partner up with an array of top specialists in order to offer the highest quality services and treatments. Collaborating with the top talents we guarantee an impeccable experience from the first visit until the end of the treatment. Every professional our client will find since they initiate contact with us will make them feel comfortable, taken care of and in safe hands.',
        alHeading: 'مهمتنا',
        alText: 'مهمتنا هي التعاون مع مجموعة من كبار المتخصصين من أجل تقديم خدمات وعلاجات عالية الجودة. بالتعاون مع أفضل المواهب، نضمن تجربة لا تشوبها شائبة من الزيارة الأولى حتى نهاية العلاج. كل محترف سيجده عميلنا منذ أن يبدأ الاتصال بنا سيجعله يشعر بالراحة والرعاية وفي أيد أمينة.',
        glHeading: 'Unsere Mission',
        glText: 'Unsere Mission ist es, mit einer Reihe von Top-Spezialisten zusammenzuarbeiten, um Dienstleistungen und Behandlungen von höchster Qualität anzubieten. Durch die Zusammenarbeit mit den besten Talenten garantieren wir ein tadelloses Erlebnis vom ersten Besuch bis zum Ende der Behandlung. Jeder Fachmann, den unser Kunde findet, wird ihm vom ersten Kontakt an das Gefühl geben, sich wohl, gut betreut und in sicheren Händen zu fühlen.'
    }
];
const serviceScreenData = [
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2020.png',
        name: 'Ophthalmology & Lid plastic surgeries',
        alName: 'طب العيون وجراحات الجفن التجميلية',
        glName: 'Augenheilkunde & Lidchirurgie'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2019.png',
        name: 'Pediatrics',
        alName: 'طب الأطفال',
        glName: 'Pädiatrie'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2033.png',
        name: 'Gynecology',
        alName: 'طب النساء',
        glName: 'Gynäkologie'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2035.png',
        name: 'Dentistry',
        alName: 'طب الأسنان',
        glName: 'Zahnmedizin'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2034.png',
        name: 'Dermatology & cosmetology',
        alName: 'الأمراض الجلدية والتجميل',
        glName: 'Dermatologie & Kosmetologie'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2018.png',
        name: 'ENT',
        alName: 'الأنف والأذن والحنجرة',
        glName: 'HNO (Hals-Nasen-Ohren)'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2015.png',
        name: 'Venereology',
        alName: 'طب الأمراض التناسلية',
        glName: 'Venerologie'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2032.png',
        name: 'Neurology',
        alName: 'طب الأعصاب',
        glName: 'Neurologie'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2017.png',
        name: 'Nutrition',
        alName: 'التغذية',
        glName: 'Ernährung'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2021.png',
        name: 'Nephrology and urology',
        alName: 'طب الكلى والمسالك البولية',
        glName: 'Nephrologie und Urologie'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2024.png',
        name: 'Orthopedic',
        alName: 'طب العظام',
        glName: 'Orthopädie'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2027.png',
        name: 'Diabetes & endocrines',
        alName: 'داء السكري والغدد الصماء',
        glName: 'Diabetes & Endokrinologie'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2028.png',
        name: 'Hypertension',
        alName: 'ارتفاع ضغط الدم',
        glName: 'Hypertonie'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2014.png',
        name: 'GIT/Hyperlipidimia',
        alName: 'الجهاز الهضمي/فرط شحميات الدم',
        glName: 'GIT/Hyperlipidämie'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2026.png',
        name: 'Screening & preventive care of healthy adults',
        alName: 'الفحص والرعاية الوقائية للبالغين الأصحاء',
        glName: 'Screening & Präventivpflege für gesunde Erwachsene'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2025.png',
        name: 'Haematology',
        alName: 'أمراض الدم',
        glName: 'Hämatologie'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2022.png',
        name: 'Geriatric',
        alName: 'طب الشيخوخة',
        glName: 'Geriatrie'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2012@2x.png',
        name: 'Doppler',
        alName: 'موجات دوبلر',
        glName: 'Doppler'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2013@2x.png',
        name: 'Sonar',
        alName: 'موجات صوتية',
        glName: 'Sonar'
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Icons/Asset%2014@2x.png',
        name: 'Medical Lab',
        alName: 'مختبر طبي',
        glName: 'Medizinisches Labor'
    },
];
const doctorData = [
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Doctors/Dr.Mohamad%20Omar.jpg',
        name: 'Dr. Mohamad Omar',
        role: 'Consultant of Pediatrics',
        specialty: 'Pediatrics',
        subSpecialty1: 'Neonatal',
        subSpecialty2: 'Pediatric Intensive Care',
        about: ['Consultant of Pediatrics intensive care and neonatal'],
        alName: 'الدكتور محمد عمر',
        alRole: 'استشاري طب الأطفال',
        alSpecialty: 'طب الأطفال',
        alSubSpecialty1: 'حديثي الولادة',
        alSubSpecialty2: 'العناية المركزة للأطفال',
        alAbout: ['استشاري العناية المركزة لطب الأطفال وحديثي الولادة'],
        glName: 'Dr. Mohamad Omar',
        glRole: 'Berater für Pädiatrie',
        glSpecialty: 'Pädiatrie',
        glSubSpecialty1: 'Neonatologie',
        glSubSpecialty2: 'Pädiatrische Intensivpflege',
        glAbout: ['Berater für pädiatrische Intensivpflege und Neonatologie']
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Doctors/Dr.Tarek%20Salah.jpg',
        name: 'Dr. Tarek Salah',
        role: 'Professor at Faculty of Dentistry Ain Shams University',
        specialty: 'Dentist',
        subSpecialty1: 'Restoratve dentistry',
        subSpecialty2: 'Crown and bridge',
        about: ['Former Dean of Faculty of Dental', 'School Ain Shams University', 'National prize in Medical Science 1998'],
        alName: 'الدكتور طارق صلاح',
        alRole: 'أستاذ في كلية طب الأسنان جامعة عين شمس',
        alSpecialty: 'طبيب أسنان',
        alSubSpecialty1: 'طب الأسنان الترميمي',
        alSubSpecialty2: 'التاج والجسر',
        alAbout: ['عميد سابق لكلية طب الأسنان', 'جامعة عين شمس', 'الجائزة الوطنية في العلوم الطبية 1998'],
        glName: 'Dr. Tarek Salah',
        glRole: 'Professor an der Fakultät für Zahnmedizin der Ain Shams Universität',
        glSpecialty: 'Zahnarzt',
        glSubSpecialty1: 'Restaurative Zahnmedizin',
        glSubSpecialty2: 'Krone und Brücke',
        glAbout: ['Ehemaliger Dekan der Fakultät für Zahnmedizin', 'Ain Shams Universität', 'Nationalpreis für Medizinische Wissenschaft 1998']
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Doctors/Dr.May%20Hobrok.jpg',
        name: 'Dr. May Hobrok',
        role: 'Consultant Obstetrician Gynecologist',
        specialty: 'Obstetrician Gynecologist',
        about: ['Highly experienced obstetrician and gynecologist for over 30 years'],
        alName: 'الدكتورة مي حبروك',
        alRole: 'استشارية أمراض النساء والتوليد',
        alSpecialty: 'أمراض النساء والتوليد',
        alAbout: ['طبيبة نساء وتوليد ذات خبرة تزيد عن 30 عامًا'],
        glName: 'Dr. May Hobrok',
        glRole: 'Beraterin für Geburtshilfe und Gynäkologie',
        glSpecialty: 'Geburtshelferin Gynäkologin',
        glAbout: ['Hoch erfahrene Geburtshelferin und Gynäkologin mit über 30 Jahren Erfahrung']
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Doctors/Dr.Hesham%20Eissa.jpg',
        name: 'Dr. Hesham Eissa',
        role: 'Consultant of Ophthalmology & Refractive Surgery',
        specialty: 'Ophthalmology',
        subSpecialty1: 'Cornea',
        subSpecialty2: 'Lasik',
        about: ['Certified trainer for Lasik procedures at Visx international', 'Introduced many innovative surgical procedures for lamellar corneal grafting'],
        alName: 'الدكتور هشام عيسى',
        alRole: 'استشاري طب وجراحة العيون',
        alSpecialty: 'طب العيون',
        alSubSpecialty1: 'القرنية',
        alSubSpecialty2: 'ليزك',
        alAbout: ['مدرب معتمد لإجراءات الليزك في Visx الدولية', 'قدم العديد من الإجراءات الجراحية المبتكرة لترقيع القرنية الصفائحي'],
        glName: 'Dr. Hesham Eissa',
        glRole: 'Berater für Augenheilkunde & Refraktive Chirurgie',
        glSpecialty: 'Augenheilkunde',
        glSubSpecialty1: 'Hornhaut',
        glSubSpecialty2: 'Lasik',
        glAbout: ['Zertifizierter Trainer für Lasik-Verfahren bei Visx international', 'Einführung vieler innovativer chirurgischer Verfahren für lamellare Hornhauttransplantationen']
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Doctors/Dr.Mamdouh%20Mahdy.jpg',
        name: 'Dr. Mamdouh Mahdy',
        role: 'Professor of Internal Medicine & Nephrology',
        specialty: 'Internal Medicine',
        subSpecialty1: 'Kidney diseases',
        subSpecialty2: 'Hemodialysis',
        about: [
            'Member of the medical sector.',
            'Supreme Council of universities SCU.',
            'Member of EU Dialysis and Trans-plantation Association EDTA.',
            'Egyptian Society of Nephrology ESN.',
            'Head Of Supreme medical committee Helwan University',
            'Chancellor of the medical affairs at Helwan University',
            'Chairman of the University hospitals at Helwan University',
            'Consultant internal medicine and nephrology.',
            'Management of renal insufficiency, conservative renal replacement therapy.',
            'Dialysis transplantation and diabetic nephrology.'
        ],
        alName: 'الدكتور ممدوح مهدي',
        alRole: 'أستاذ الطب الباطني وأمراض الكلى',
        alSpecialty: 'الطب الباطني',
        alSubSpecialty1: 'أمراض الكلى',
        alSubSpecialty2: 'غسيل الكلى',
        alAbout: [
            'عضو في القطاع الطبي.',
            'المجلس الأعلى للجامعات.',
            'عضو في الاتحاد الأوروبي لغسيل الكلى وزرع الكلى.',
            'الجمعية المصرية لأمراض الكلى.',
            'رئيس اللجنة الطبية العليا بجامعة حلوان',
            'مستشار الشؤون الطبية بجامعة حلوان',
            'رئيس مستشفيات الجامعة بجامعة حلوان',
            'استشاري الطب الباطني وأمراض الكلى.',
            'إدارة الفشل الكلوي، العلاج البديل المحافظ للكلى.',
            'زرع الكلى وغسيل الكلى واعتلال الكلى السكري.'
        ],
        glName: 'Dr. Mamdouh Mahdy',
        glRole: 'Professor für Innere Medizin & Nephrologie',
        glSpecialty: 'Innere Medizin',
        glSubSpecialty1: 'Nierenerkrankungen',
        glSubSpecialty2: 'Hämodialyse',
        glAbout: [
            'Mitglied des medizinischen Sektors.',
            'Oberster Rat der Universitäten SCU.',
            'Mitglied der EU Dialyse- und Transplantationsvereinigung EDTA.',
            'Ägyptische Gesellschaft für Nephrologie ESN.',
            'Leiter des obersten medizinischen Ausschusses der Helwan-Universität',
            'Kanzler der medizinischen Angelegenheiten an der Helwan-Universität',
            'Vorsitzender der Universitätskliniken an der Helwan-Universität',
            'Berater für Innere Medizin und Nephrologie.',
            'Management von Niereninsuffizienz, konservative Nierenersatztherapie.',
            'Dialyse-Transplantation und diabetische Nephrologie.'
        ]
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Doctors/Dr.Marwa%20Eltawil.jpg',
        name: 'Dr. Marwa Eltawil',
        role: 'Specialist in Clinical Nutrition',
        specialty: 'Clinical Nutritionist',
        about: [
            'Certified clinical nutritionist from AACME (American Association for continuing medical education).',
            'Certified specialist in fitness nutrition from the ISSA (International Sports Sciences Association).',
            'Member of the Egyptian Arab Society for Healthy and Therapeutic Nutrition (EASHTN).',
            'She provides customized nutrition plans for the following:',
            'Adults & Children weight.',
            'Obesity management.',
            'Diabetes.',
            'Hypertension',
            'Detox diet plans.',
            'Pregnant and lactating women.',
            'Eating disorders.',
            'Food intolerance assessment.'
        ],
        alName: 'الدكتورة مروة الطاويل',
        alRole: 'أخصائي التغذية السريرية',
        alSpecialty: 'أخصائي تغذية سريرية',
        alAbout: [
            'أخصائية تغذية سريرية معتمدة من AACME (الجمعية الأمريكية للتعليم الطبي المستمر).',
            'أخصائية تغذية لياقة معتمدة من ISSA (جمعية العلوم الرياضية الدولية).',
            'عضو في الجمعية المصرية العربية للتغذية الصحية والعلاجية (EASHTN).',
            'توفر خطط تغذية مخصصة للمجموعات التالية:',
            'وزن البالغين والأطفال.',
            'إدارة السمنة.',
            'السكري.',
            'ارتفاع ضغط الدم',
            'خطط الحمية التخلص من السموم.',
            'النساء الحوامل والمرضعات.',
            'اضطرابات الأكل.',
            'تقييم تحمل الطعام.'
        ],
        glName: 'Dr. Marwa Eltawil',
        glRole: 'Spezialistin für klinische Ernährung',
        glSpecialty: 'Klinische Ernährungsberaterin',
        glAbout: [
            'Zertifizierte klinische Ernährungsberaterin von AACME (American Association for Continuing Medical Education).',
            'Zertifizierte Spezialistin für Fitnessernährung von der ISSA (International Sports Sciences Association).',
            'Mitglied der ägyptischen Arabischen Gesellschaft für gesunde und therapeutische Ernährung (EASHTN).',
            'Sie bietet maßgeschneiderte Ernährungspläne für die folgenden Gruppen an:',
            'Gewicht von Erwachsenen & Kindern.',
            'Adipositas-Management.',
            'Diabetes.',
            'Bluthochdruck',
            'Detox-Diätpläne.',
            'Schwangere und stillende Frauen.',
            'Essstörungen.',
            'Bewertung der Lebensmittelunverträglichkeit.'
        ]
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Doctors/Dr.Mohamad%20Raeya.jpg',
        name: 'Dr. Mohamad Raeya',
        role: 'Professor of Venerology, Cairo University',
        specialty: 'Venerology',
        about: ['Consultant of male infertility, sexual transmitted diseases, and sexual problems.'],
        alName: 'الدكتور محمد راية',
        alRole: 'أستاذ الأمراض التناسلية، جامعة القاهرة',
        alSpecialty: 'الأمراض التناسلية',
        alAbout: ['استشاري في العقم الذكوري، الأمراض المنقولة جنسياً، والمشاكل الجنسية.'],
        glName: 'Dr. Mohamad Raeya',
        glRole: 'Professor der Venerologie, Kairo Universität',
        glSpecialty: 'Venerologie',
        glAbout: ['Berater für männliche Unfruchtbarkeit, sexuell übertragbare Krankheiten und sexuelle Probleme.']
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Doctors/Dr.Mohamad%20Saher.jpg',
        name: 'Dr. Mohamad Saher',
        role: 'Consultant of Neurology',
        specialty: 'Neurology',
        about: [
            'MD Neurology, Cairo University',
            'Fellow Carl Gustaf University, Germany.',
            'Member of World Stroke Organization.',
            'Consultant at Dar Al Fouad Hospital.'
        ],
        alName: 'الدكتور محمد ساهر',
        alRole: 'استشاري طب الأعصاب',
        alSpecialty: 'طب الأعصاب',
        alAbout: [
            'دكتوراه في طب الأعصاب، جامعة القاهرة',
            'زميل جامعة كارل غوستاف، ألمانيا.',
            'عضو في المنظمة العالمية للسكتة الدماغية.',
            'استشاري في مستشفى دار الفؤاد.'
        ],
        glName: 'Dr. Mohamad Saher',
        glRole: 'Berater für Neurologie',
        glSpecialty: 'Neurologie',
        glAbout: [
            'MD Neurologie, Kairo Universität',
            'Fellow Carl Gustaf Universität, Deutschland.',
            'Mitglied der World Stroke Organization.',
            'Berater im Dar Al Fouad Krankenhaus.'
        ]
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Doctors/Dr.Hany%20Tarek.jpg',
        name: 'Dr. Hany Tarek',
        role: 'Specialist of Fixed Prosthodontics & Dental Aesthetics',
        specialty: 'Dentist',
        about: [
            'Former lecturer of fixed prosthodontics, the British University of Egypt',
            'Certified smile makeover trainer for Glamsmile international'
        ],
        alName: 'الدكتور هاني طارق',
        alRole: 'أخصائي تركيبات الأسنان الثابتة وجماليات الأسنان',
        alSpecialty: 'طبيب أسنان',
        alAbout: [
            'محاضر سابق لتركيبات الأسنان الثابتة في الجامعة البريطانية في مصر',
            'مدرب معتمد لتجميل الابتسامة من Glamsmile الدولية'
        ],
        glName: 'Dr. Hany Tarek',
        glRole: 'Spezialist für festsitzende Prothetik & Zahnästhetik',
        glSpecialty: 'Zahnarzt',
        glAbout: [
            'Ehemaliger Dozent für festsitzende Prothetik an der British University of Egypt',
            'Zertifizierter Trainer für Smile-Makeover bei Glamsmile international'
        ]
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Doctors/Dr.Mohamad%20Talaat.jpg',
        name: 'Dr. Mohamad Talaat',
        role: 'Professor of Internal Medicine and Clinical Hematology',
        specialty: 'Internal Medicine',
        subSpecialty1: 'Hematology',
        subSpecialty2: 'Preventive health screening',
        about: [
            'Professor of internal medicine with its medical services and scope of care.',
            'Expert in blood diseases that include all types of chronic anemia and hereditary anemia.',
            'Expert in management of bleeding disorders: both hereditary and acquired with its different reasons',
            'Specialized to treat blood oncology (tumors) and lymphatic diseases.',
            'Specialized in immune system diseases and health.',
            'Worked as Consultant in Johns Hopkins Saudi Arabia in the field of preventive medicine and screening healthy individuals.'
        ],
        alName: 'الدكتور محمد طلعت',
        alRole: 'أستاذ الطب الباطني وأمراض الدم السريرية',
        alSpecialty: 'الطب الباطني',
        alSubSpecialty1: 'أمراض الدم',
        alSubSpecialty2: 'الفحص الصحي الوقائي',
        alAbout: [
            'أستاذ الطب الباطني مع خدماته الطبية ونطاق الرعاية.',
            'خبير في أمراض الدم التي تشمل جميع أنواع فقر الدم المزمن وفقر الدم الوراثي.',
            'خبير في إدارة اضطرابات النزيف: سواء الوراثية والمكتسبة مع أسبابها المختلفة',
            'متخصص في علاج الأورام الدموية (الأورام) وأمراض الجهاز الليمفاوي.',
            'متخصص في أمراض الجهاز المناعي والصحة.',
            'عمل كاستشاري في مستشفى جونز هوبكنز السعودية في مجال الطب الوقائي وفحص الأفراد الأصحاء.'
        ],
        glName: 'Dr. Mohamad Talaat',
        glRole: 'Professor für Innere Medizin und Klinische Hämatologie',
        glSpecialty: 'Innere Medizin',
        glSubSpecialty1: 'Hämatologie',
        glSubSpecialty2: 'Präventive Gesundheitsvorsorge',
        glAbout: [
            'Professor für Innere Medizin mit seinen medizinischen Dienstleistungen und Pflegeumfang.',
            'Experte für Blutkrankheiten, die alle Arten von chronischer Anämie und erblicher Anämie umfassen.',
            'Experte für das Management von Blutungsstörungen: sowohl erbliche als auch erworbene mit verschiedenen Ursachen',
            'Spezialisiert auf die Behandlung von Blutonkologie (Tumoren) und lymphatischen Erkrankungen.',
            'Spezialisiert auf Krankheiten und Gesundheit des Immunsystems.',
            'Arbeitete als Berater bei Johns Hopkins Saudi-Arabien im Bereich der präventiven Medizin und der Untersuchung gesunder Personen.'
        ]
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Doctors/Dr.Samir%20Fanous.jpg',
        name: 'Dr. Samir Fanous',
        role: 'Consultant orthopedic & trauma surgeon',
        specialty: 'Orthopaedic',
        subSpecialty1: 'Sports injuries',
        subSpecialty2: 'Arthroscopic surgery',
        about: ['Consultant orthopedic and trauma surgeon, sports injuries arthroscopic surgery.', 'Total joint arthroplasty'],
        alName: 'الدكتور سمير فانوس',
        alRole: 'استشاري جراحة العظام والرضوح',
        alSpecialty: 'جراحة العظام',
        alSubSpecialty1: 'إصابات رياضية',
        alSubSpecialty2: 'جراحة تنظير المفاصل',
        alAbout: ['استشاري جراحة العظام والرضوح، إصابات رياضية وجراحة تنظير المفاصل.', 'استبدال المفاصل الكلي'],
        glName: 'Dr. Samir Fanous',
        glRole: 'Berater für Orthopädie & Traumatologie',
        glSpecialty: 'Orthopädie',
        glSubSpecialty1: 'Sportverletzungen',
        glSubSpecialty2: 'Arthroskopische Chirurgie',
        glAbout: ['Berater für Orthopädie und Traumatologie, Sportverletzungen arthroskopische Chirurgie.', 'Totaler Gelenkersatz']
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Doctors/Dr.Tarek%20Reda.jpg',
        name: 'Dr.Tarek Reda',
        role: 'Consultant of Clinical Nutrition Medicine & Metabolism',
        specialty: 'Clinical Nutritionist',
        about: [
            'President, Egyptian Society for Public Health & Nutrition.',
            'Consultant of Clinical Nutrition Medicine & Metabolism',
            'Founder, Obesity Research & Management Center, National Nutrition Institute, Cairo',
            'Fellow, Institute of Human Nutrition, Columbia University, USA'
        ],
        alName: 'الدكتور طارق رضا',
        alRole: 'استشاري طب التغذية السريرية والتمثيل الغذائي',
        alSpecialty: 'أخصائي تغذية سريرية',
        alAbout: [
            'رئيس الجمعية المصرية للصحة العامة والتغذية.',
            'استشاري طب التغذية السريرية والتمثيل الغذائي',
            'مؤسس مركز أبحاث وإدارة السمنة، المعهد الوطني للتغذية، القاهرة',
            'زميل معهد التغذية البشرية، جامعة كولومبيا، الولايات المتحدة الأمريكية'
        ],
        glName: 'Dr.Tarek Reda',
        glRole: 'Berater für Klinische Ernährungsmedizin & Stoffwechsel',
        glSpecialty: 'Klinischer Ernährungsberater',
        glAbout: [
            'Präsident der ägyptischen Gesellschaft für öffentliche Gesundheit & Ernährung.',
            'Berater für Klinische Ernährungsmedizin & Stoffwechsel',
            'Gründer des Adipositas-Forschungs- & Managementzentrums, Nationales Ernährungsinstitut, Kairo',
            'Fellow des Institute of Human Nutrition, Columbia University, USA'
        ]
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Doctors/Dr.Ahmad%20Abdelkhalek.jpg',
        name: 'Dr.Ahmad Abdelkhalek',
        role: 'Consultant of Ear, Nose, Throat and Nasal',
        specialty: 'Ears - Nose - Throat',
        subSpecialty1: 'Nasal Disease',
        subSpecialty2: 'Hearing Deficit',
        about: [
            'Use of the cutting end technology in examination procedures including endoscopic examination of ear, nose and throat',
            'Endoscope sinus surgery',
            'Nasal allergy',
            'Snoring management',
            'Otology'
        ],
        alName: 'الدكتور أحمد عبد الخالق',
        alRole: 'استشاري الأذن والأنف والحنجرة',
        alSpecialty: 'الأذن - الأنف - الحنجرة',
        alSubSpecialty1: 'أمراض الأنف',
        alSubSpecialty2: 'نقص السمع',
        alAbout: [
            'استخدام أحدث التقنيات في إجراءات الفحص بما في ذلك الفحص بالمنظار للأذن والأنف والحنجرة',
            'جراحة الجيوب الأنفية بالمنظار',
            'حساسية الأنف',
            'إدارة الشخير',
            'علم الأذن'
        ],
        glName: 'Dr.Ahmad Abdelkhalek',
        glRole: 'Berater für Ohren, Nase, Hals und Nasen',
        glSpecialty: 'Ohren - Nase - Hals',
        glSubSpecialty1: 'Nasenerkrankungen',
        glSubSpecialty2: 'Hörverlust',
        glAbout: [
            'Einsatz modernster Technologien bei Untersuchungsverfahren, einschließlich endoskopischer Untersuchungen von Ohr, Nase und Hals',
            'Endoskopische Nasennebenhöhlenchirurgie',
            'Nasale Allergie',
            'Schnarchmanagement',
            'Ohrheilkunde'
        ]
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Doctors/Dr.Anwar%20Helmy.jpg',
        name: 'Dr.Anwar Helmy',
        role: 'Consultant of Urology',
        specialty: 'Urology',
        subSpecialty1: 'Pediatrics',
        subSpecialty2: 'Oncology',
        about: ['Former chairman of EgyptAir hospital.', 'Consultant of Urology and oncology.'],
        alName: 'الدكتور أنور حلمي',
        alRole: 'استشاري أمراض المسالك البولية',
        alSpecialty: 'المسالك البولية',
        alSubSpecialty1: 'طب الأطفال',
        alSubSpecialty2: 'طب الأورام',
        alAbout: ['رئيس سابق لمستشفى مصر للطيران.', 'استشاري أمراض المسالك البولية والأورام.'],
        glName: 'Dr.Anwar Helmy',
        glRole: 'Berater für Urologie',
        glSpecialty: 'Urologie',
        glSubSpecialty1: 'Pädiatrie',
        glSubSpecialty2: 'Onkologie',
        glAbout: ['Ehemaliger Vorsitzender des EgyptAir-Krankenhauses.', 'Berater für Urologie und Onkologie.']
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Doctors/Dr.Ahmad%20el%20Taher.jpg',
        name: 'Dr.Ahmad el Taher',
        role: 'Consultant of Aesthetic Gynecology',
        specialty: 'Aesthetic Gynecology',
        subSpecialty1: 'Sonar',
        subSpecialty2: 'Endoscope',
        about: ['Consultant Of Gynecology', 'Aesthetic Gynecology surgeries'],
        alName: 'الدكتور أحمد الطاهر',
        alRole: 'استشاري أمراض النساء التجميلية',
        alSpecialty: 'طب النساء التجميلي',
        alSubSpecialty1: 'السونار',
        alSubSpecialty2: 'المنظار',
        alAbout: ['استشاري أمراض النساء', 'جراحات النساء التجميلية'],
        glName: 'Dr.Ahmad el Taher',
        glRole: 'Berater für Ästhetische Gynäkologie',
        glSpecialty: 'Ästhetische Gynäkologie',
        glSubSpecialty1: 'Sonar',
        glSubSpecialty2: 'Endoskop',
        glAbout: ['Berater für Gynäkologie', 'Ästhetische Gynäkologie Operationen']
    },
    {
        img: 'https://www.cairocapitalclinics.com/images/Images/Doctors/Dr.Amir%20mostafa.jpg',
        name: 'Dr.Amir Mostafa',
        role: 'Consultant & Therapeutic Coronary Catheterization',
        specialty: 'Cardiology',
        subSpecialty1: 'Hypertension',
        subSpecialty2: 'Echo',
        about: [
            'Consultant of cardiovascular medicine.',
            'Specialized in treating cardiac diseases and hypertension',
            'Specialized in echocardiography and vascular duplex.',
            'Specialized in invasive diagnostic and therapeutic coronary catheterization for treating coronary disease in including unstable angina and myocardial infarction.'
        ],
        alName: 'الدكتور أمير مصطفى',
        alRole: 'استشاري القسطرة القلبية العلاجية',
        alSpecialty: 'أمراض القلب',
        alSubSpecialty1: 'ارتفاع ضغط الدم',
        alSubSpecialty2: 'التصوير بالأشعة الصوتية',
        alAbout: [
            'استشاري في طب القلب والأوعية الدموية.',
            'متخصص في علاج أمراض القلب وارتفاع ضغط الدم',
            'متخصص في تخطيط صدى القلب ودوبلكس الأوعية الدموية.',
            'متخصص في القسطرة القلبية التشخيصية والعلاجية الغازية لعلاج أمراض الشريان التاجي بما في ذلك الذبحة الصدرية غير المستقرة واحتشاء عضلة القلب.'
        ],
        glName: 'Dr.Amir Mostafa',
        glRole: 'Berater für therapeutische Koronar-Katheterisierung',
        glSpecialty: 'Kardiologie',
        glSubSpecialty1: 'Bluthochdruck',
        glSubSpecialty2: 'Echo',
        glAbout: [
            'Berater für kardiovaskuläre Medizin.',
            'Spezialisiert auf die Behandlung von Herzkrankheiten und Bluthochdruck',
            'Spezialisiert auf Echokardiographie und vaskulären Duplex.',
            'Spezialisiert auf invasive diagnostische und therapeutische Koronar-Katheterisierung zur Behandlung von koronaren Erkrankungen, einschließlich instabiler Angina und Myokardinfarkt.'
        ]
    }
]

export {
    menuItems,
    homeExperienceData,
    serviceData,
    patientFeedBackData,
    latestOffer,
    aboutData,
    serviceScreenData,
    doctorData
}